import PropTypes from 'prop-types';
import styles from './FJVoiceStyleSelect.module.less';
import FJDropdownNew from '../../../../common/components/FJDropDown/FJDropdownNew.jsx';
import FJArrowIcon from '../../../../assets/svg/ttv/arrow-down.svg?react';
import classNames from 'classnames';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller.jsx';
import { useRef } from 'react';

const FJVoiceStyleSelect = props => {
    const { style, onChange, value, list = [] } = props;
    const _dropDownRef = useRef(null);
    const _renderTrigger = config => {
        const showValue = list.find(item => item.value === value)?.label;
        return (
            <div className={styles.value} onClick={config.onClick} ref={config.ref} style={style}>
                <span className={styles.text}>{FJLocalStore._(showValue)}</span>
                <FJArrowIcon className={styles.icon} />
            </div>
        );
    };

    const _renderOverlay = () => {
        return (
            <div className={styles.box}>
                <FJVerticalScroller style={{ height: Math.min(36 * 6, 36 * list.length + 2) }}>
                    {list.map((item, index) => {
                        return (
                            <div
                                className={classNames(styles.item, item.value === value ? styles.active : '')}
                                key={index}
                                onClick={() => {
                                    _dropDownRef.current.hide();
                                    onChange(item.value);
                                }}
                            >
                                {FJLocalStore._(item.label)}
                            </div>
                        );
                    })}
                </FJVerticalScroller>
            </div>
        );
    };

    return (
        <FJDropdownNew
            isTopLayer={true}
            renderTrigger={_renderTrigger}
            useAnchorBody
            renderOverlay={_renderOverlay}
            offsetTop={5}
            ref={_dropDownRef}
        />
    );
};

FJVoiceStyleSelect.propTypes = {
    style: PropTypes.object,
    onChange: PropTypes.func,
    value: PropTypes.string,
    list: PropTypes.array,
};
export default FJVoiceStyleSelect;
